<div class="text-center"
    [ngClass]="{ 'im3' : platform === 'im3', 'indosat' : platform === 'indosat' || platform === 'tri' }">
    <img src="assets/img/dialog-error.png" class="icon-confirmation"/>
    <h1
        [ngClass]="{ 'im3-bold' : platform === 'im3', 'indosat-bold' : platform === 'indosat', 'tri-bold' : platform === 'tri' }">
        {{ "confirmation_title" | translate }}
    </h1>
    <p>
        {{ "confirmation_content" | translate }}
    </p>
    <div class="box-info">
        <img src="assets/img/alert-icon-black.png" class="icon-info" />
        {{ "confirmation_sure" | translate }}
    </div>
    <div class="row btn-wrapper">
        <div class="col-12">
            <button class="btn-agree" data-bs-dismiss="offcanvas" aria-label="Close"
                [ngClass]="{ 'im3-bold' : platform === 'im3', 'indosat-bold' : platform === 'indosat', 'bg-orange' : platform === 'tri' }"
                type="button" (click)="save(1)">
                {{ "agreePersonalized" | translate}}
            </button>
        </div>
        <div class="col-12">
            <button class="btn-disagree" data-bs-dismiss="offcanvas" aria-label="Close"
                [ngClass]="{ 'im3-bold' : platform === 'im3', 'indosat-bold' : platform === 'indosat', 'text-orange' : platform === 'tri' }"
                type="button" (click)="save(0)">
                {{ "disagreePersonalized" | translate}}
            </button>
        </div>
    </div>
</div>